
        <div class="bk-tab__container tab" [hidden]="!selected">
            <ng-content></ng-content>
        </div>
    